import { useEffect, useMemo, useState } from "react";
import ProgressSpinner from "../../../views/components/progress_spinner";
import Table from "../../../views/components/table";
import { Link, useNavigate } from "react-router-dom";
import { commonConfigs, urls } from "../../../../config";
import axios from "axios";
import beveatApiResourceOwner from "../../../api/resource_owner_beveat_api.js";
import { getUser } from "../../../services/local_service.js";
import { DEVELOPER_PROJ_TABLE_SYSCODE } from "../../../constants/developer_proj_table_syscode";

export default function ProductionPlan({ isMobile }) {
  const [productionPlans, setProductionPlans] = useState();
  const [productionData, setProductionData] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const ssoId = getUser()?.sso_id;
  const getProductionPricePlansUrl =
    urls.resourceOwnerUrl + commonConfigs.apiUrls.getProductionPlans();
  const getAllProductionDeveloperProjectsUrl =
    urls.resourceOwnerUrl +
    commonConfigs.apiUrls.GetAllDeveloperProjects(ssoId, DEVELOPER_PROJ_TABLE_SYSCODE.PRODUCTION);
  const navigate = useNavigate();

  async function getProductionPlans() {
    await beveatApiResourceOwner
      .get(getProductionPricePlansUrl, {
        headers: commonConfigs.resourceOwnerApiHeader,
      })
      .then((res) => {
        const mockData = [
          {
            invoice_plan: "nets.openapipaas.com",
            invoice_plan_variable_rate: "-",
            invoice_plan_description: "To be confirm on later date",
          },
          {
            invoice_plan: "foodservices.openapipaas.com",
            invoice_plan_variable_rate: "-",
            invoice_plan_description: "To be confirm on later date",
          },
        ]
        setProductionPlans(mockData);
        // setProductionPlans(res.data.result.data);
        // console.log("Production Plans: ", res);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function getProductionDeveloperProjects() {
    await beveatApiResourceOwner
      .get(getAllProductionDeveloperProjectsUrl, {
        headers: commonConfigs.resourceOwnerApiHeader,
      })
      .then((res) => {
        setProductionData(res.data.result.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  useEffect(() => {
    getProductionPlans().catch((err) => {
      console.log("err for production plans: " + err);
    });
    getProductionDeveloperProjects();
  }, []);

  const columns = useMemo(() => [
    {
      Header: "Project API",
      accessor: "invoice_plan",
    },
    {
      Header: "Variable Rate",
      accessor: "invoice_plan_variable_rate",
    },
    {
      Header: "Description",
      accessor: "invoice_plan_description",
    },
  ], []);

  // const onHandleGetStarted = () => {
  //   const disableButton = productionData.some(
  //     (project) => project.developer_proj_agreement !== 1
  //   );
  //   if (disableButton) {
  //     setIsDisabled(disableButton);
  //     alert("You have not signed the agreement!");
  //   } else {
  //     navigate("/projects/create", {
  //       state: {
  //         presetEnvironment: { value: "1", label: "Production" },
  //         isProd: 1,
  //       },
  //     });
  //   }
  // };

  return (
    <>
      <div className="w-full">
        {productionPlans != null ? (
          <>
            {/* Mobile-responsive table container */}
            <div className={`${isMobile ? 'overflow-x-auto' : ''}`}>
              <Table
                columns={columns}
                data={productionPlans}
                filters={columns.map((column) => column.accessor)}
                isMobile={isMobile}
              />
            </div>

            {/* Mobile-responsive button */}
            <div className={`${isMobile
              ? 'w-full mt-4'
              : 'flex justify-end'
              }`}>
              {/* <button
                type="button"
                onClick={onHandleGetStarted}
                className={`hover:bg-blue-500 text-blue-500 hover:text-white outline outline-blue-500 font-bold py-2 px-12 rounded-md transition-colors duration-200 ${isMobile
                  ? 'w-full'
                  : ''
                  }`}
                style={isMobile ? {} : { float: "right", marginTop: "-50px" }}
              >
                Get Started
              </button> */}
            </div>
          </>
        ) : (
          <div className={`${isMobile
            ? 'min-h-64 flex items-center justify-center'
            : 'w-screen h-screen flex flex-wrap flex-row place-items-center'
            }`}>
            <div className="flex place-content-center w-full">
              <ProgressSpinner className={`${isMobile ? 'w-12 h-12' : 'w-20 h-20'}`} />
            </div>
          </div>
        )}
      </div>
    </>
  );
}